import { type ItemType, type ResourceId } from '../common/structs';
export const wishlists = {
    audit:
        // TODO: use these links & remove admin once this is moved to non-admin route on BE
        {
            wishlist: `/wishlists/audit`,
            items: `/wishlist_items/audit`,
        },
    collection: `/wishlists`,
    userCollection: (userId: ResourceId) => `/wishlists/user/${userId}`,
    itemsByKey: (key: string) => `/${wishlists.collection}/search?wishlist_items=${key}`,
    single: (slug: ResourceId) =>
        ({
            replace: () => `/wishlists/${slug}/replace`,
            follow: () => `/wishlists/${slug}/follow`,
            items: () => `/wishlists/${slug}/items`,
            itemsByType: (type: ItemType) => `/wishlists/${slug}/items/${type}`,
            submit: () => `/wishlists/${slug}/submit`,
            summary: () => `/wishlists/${slug}/portfolio-summary`,
            wishlist: () => `/wishlists/${slug}`,
        }) as const,
};
